import BaseElement from './BaseElement';
import CommentList from '../Components/CommentList';
class CommentListElement extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = CommentList;
    }
}
export default CommentListElement;
